import { render, staticRenderFns } from "./AppNewInformationRequest.vue?vue&type=template&id=1debc450&scoped=true"
import script from "./AppNewInformationRequest.vue?vue&type=script&lang=js"
export * from "./AppNewInformationRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1debc450",
  null
  
)

export default component.exports